import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function ProductShowcase() {
  const features = ['Protocolo de limpieza de crédito en 90 días', 'Sistema FHA 3.5% y estrategias de House Hacking', 'Guía de inversión en Wall Street sin tecnicismos', 'Staking de Bitcoin y cripto paso a paso', 'Manifiesto de liberación financiera', 'Plantillas y mapa de acción inmediato'];
  return <section className="py-24 relative bg-navy-900" data-id="element-165">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-16 items-center" data-id="element-166">
        <FadeIn direction="right" className="relative" data-id="element-167">
          <div className="absolute inset-0 bg-gold-500/5 blur-[80px] rounded-full" data-id="element-168" />
          <img src="https://cdn.magicpatterns.com/uploads/puwmM59rgE1FXWvhvq1jbx/EL_CODIGO_DE_LA_RIQUEZA.png" alt="El Código de la Riqueza Latina - Contenido del programa" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-169" />
        </FadeIn>

        <div className="flex flex-col justify-center" data-id="element-170">
          <FadeIn delay={0.1} data-id="element-171">
            <h2 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-172">
              Todo lo que necesitas para{' '}
              <span className="italic text-gold-400" data-id="element-173">
                reescribir tu historia.
              </span>
            </h2>
          </FadeIn>

          <div className="space-y-4" data-id="element-174">
            {features.map((feature, index) => <FadeIn key={index} delay={0.2 + index * 0.1} direction="up" data-id="element-175">
                <div className="flex items-start gap-4 p-4 rounded-lg hover:bg-navy-800/50 transition-colors border border-transparent hover:border-navy-700" data-id="element-176">
                  <CheckCircle2 className="w-6 h-6 text-gold-500 shrink-0 mt-0.5" data-id="element-177" />
                  <span className="text-lg text-gray-200" data-id="element-178">{feature}</span>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}